// removed by extract-text-webpack-plugin
module.exports = {"link":"gj_ae","tight":"gj_m","active":"gj_gl","linkWrapper":"gj_gn"};


//////////////////
// WEBPACK FOOTER
// ./components/linkBlock/style.css
// module id = SNoI
// module chunks = 7